// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"PlayerLayout_playerWrapper__2lBCo","mainComponentWrapper":"PlayerLayout_mainComponentWrapper__ZLJOw"};